import React, { Component } from 'react';

import { isEmpty } from "lodash";

import { Box, OutlinedInput, InputLabel, Select, Typography, FormHelperText, FormControl } from '@mui/material';
import { Fragment } from 'react';
import { normalizeStr } from '../../../../utils/generalFuncs';
import ColorPicker from '../../../common/ColorPicker';
import Dialog from '../../../common/Dialog';
import InputText, { InputSelectNative } from '../../../common/Form';
import Creatable from '../../../common/Creatable';

class Localisation extends Component {
    state = { 
        loc_name: this.props.localisation ? this.props.localisation.loc_name : "",
        loc_parent: this.props.localisation ? this.props.localisation.loc_parent : "",
        loc_parentDisplay: this.props.localisation && this.props.localisation.loc_parent ? {
            value: this.props.localisation.loc_parent, 
            label: this.props.LOCALISATIONS.PARENT[this.props.localisation.loc_parent].loc_name
        } : {value:"", label:""},
        loc_sub_parent: this.props.localisation ? this.props.localisation.loc_sub_parent : "",
        loc_sub_parentDisplay: this.props.localisation && this.props.localisation.loc_sub_parent ? {
            value: this.props.localisation.loc_sub_parent, 
            label: this.props.LOCALISATIONS.CHILD[this.props.localisation.loc_sub_parent].loc_name
        } : {value:"", label:""},
        loc_color: this.props.localisation ? this.props.localisation.loc_color : "",
        loc_desc: this.props.localisation ? this.props.localisation.loc_desc : "",
        loc_ref: this.props.localisation ? this.props.localisation.loc_ref : "",
        loc_type: this.props.localisation ? this.props.localisation.loc_type : "",
        errors:{
            loc_name: "",
            loc_parent: "",
            loc_desc: "",
            loc_color: "",
            loc_ref: "",
            loc_type: "",
        },
        exist: []
    }
    componentDidMount = () => {
        this.getAvailableColorsList()
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        // if(name === "loc_parent" && !isEmpty(value)){
        //     let color = this.props.LOCALISATIONS.PARENT[value].loc_color
        //     this.setState({
        //         loc_color: color,
        //         loc_sub_parent: "",
        //     })
        // }

        this.setState({
            [name]: value
        })
    }
    handleChangeCat = (name, option) => {
        if(option){
            if(name === "loc_parent" && !isEmpty(option.value)){
                let color = this.props.LOCALISATIONS.PARENT[option.value].loc_color
                this.setState({
                    loc_color: color,
                    loc_sub_parent: "",
                    [name]: option.value || "",
                    [`${name}Display`]: option
                })
            } else {

                this.setState({
                    [name]: option.value || "",
                    [`${name}Display`]: option
                })
            }
        } else {
            this.setState({
                [name]: "",
                [`${name}Display`]: {}
            })

        }
    }
    setColor = (color) => {
        this.setState({
            loc_color: color
        })
    }
    
    nameExist = (name, isParent, id) => {
        const { LOCALISATIONS } = this.props;
        let list = []
        if(isParent){
            list = Object.values(LOCALISATIONS.PARENT).filter(cat => ( 
                    (normalizeStr(cat.loc_name) === normalizeStr(name) ) && 
                    (cat.loc_id !== id) 
                ))
            
        } else {
            list = Object.values(LOCALISATIONS.CHILD).filter(cat => ( 
                    (normalizeStr(cat.loc_name) === normalizeStr(name) ) && 
                    (cat.loc_id !== id) 
                ) )
        }

        console.log("Localisation exist",{list});

        return !isEmpty(list)
    }
    validate = () => {
        let required = [
            "loc_name",
            "loc_color",
            "loc_desc",
            "loc_ref",
            // "loc_type",
        ]

        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            
            if (this.props.update) {
                data = Object.assign(data, this.props.localisation)
            }

            // data.loc_name = this.state.loc_name.toUpperCase().trim()
            data.loc_name = this.state.loc_name.trim()
            data.loc_parent = this.state.loc_parent
            data.loc_type = this.state.loc_type
            data.loc_sub_parent = this.state.loc_sub_parent
            data.loc_color = this.state.loc_color
            data.loc_desc = this.state.loc_desc
            data.loc_ref = this.state.loc_ref ? this.state.loc_ref.toUpperCase().trim() : ""

            // console.log('====================================');
            // console.log({data});
            // console.log('====================================');
    
            data.is_parent = isEmpty(data.loc_parent)
            data.is_child = !isEmpty(data.loc_parent)
            
            // check if name exist
            if(this.nameExist(data.loc_name, data.is_parent, data.loc_id) ){
                this.props.notif("error",`Cette localisation existe déjà`)
                return
            }

            if(this.props.update){
                await this.props.updateLocalisation(data)
            } else {
                await this.props.newLocalisation(data)  
            }

            if(this.props.STATE.localisations.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.localisations.error}`)
            } else{
                !this.props.update && this.props.notif("success","La localisation a été créée avec succès")
                this.props.update && this.props.notif("success","La localisation a été modifiée avec succès")
                this.props.handleClose()
            }
            
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    getAvailableColorsList = () => {
        const { LOCALISATIONS } = this.props;
        let exist = []
        Object.values(LOCALISATIONS.PARENT).forEach( cat => {
            exist.push(cat.loc_color)
        })
        this.setState({
            exist
        })
    }
    render() {
        const { LOCALISATIONS } = this.props;
        return (
            <Dialog
                close={this.props.handleClose}
                title={`${this.props.update ? "Modifier la " : "Créer une nouvelle"} Localisation`}
                disabledSubmit={this.props.STATE.localisations.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
                submitAction={this.handleSubmit}
                appBar
                maxWidth="sm"
            >
                <InputText
                    required
                    name="loc_name" 
                    id="loc_name" 
                    value={this.state.loc_name} 
                    label="Nom de la localisation" 
                    error={this.state.errors.loc_name} 
                    onChange={this.handleChange}
                />

                {!this.props.hasChild &&
                    <Fragment>
                        <Creatable
                            label="Localisation Principale"
                            required
                            error={this.state.errors.loc_parent}
                            id="loc_parent"
                            options={Object.values(LOCALISATIONS.PARENT).map( item => ({
                                label: item.loc_name,
                                value: item.loc_id
                            }))}
                            value={this.state.loc_parentDisplay}
                            onChange={(option) => this.handleChangeCat("loc_parent", option)}
                        />
                        
                        {this.state.loc_parent && LOCALISATIONS.ALL[this.state.loc_parent] &&
                            <Creatable
                                label="Sous Localisation"
                                required
                                error={this.state.errors.loc_sub_parent}
                                id="loc_sub_parent"
                                options={LOCALISATIONS.ALL[this.state.loc_parent] && LOCALISATIONS.ALL[this.state.loc_parent].map( subcat => ({
                                    label: LOCALISATIONS.CHILD[subcat] && LOCALISATIONS.CHILD[subcat].loc_name,
                                    value: subcat,
                                    disabled: this.props.localisation && 
                                        subcat === this.props.localisation.loc_id
                                }))}
                                value={this.state.loc_sub_parentDisplay}
                                onChange={(option) => this.handleChangeCat("loc_sub_parent", option)}
                            />
                        }
                    </Fragment>
                }
                {!this.state.loc_parent && 
                    <InputSelectNative
                        labelWidth={60}
                        onChange={ (e) => this.setState({ loc_type: e.target.value })}
                        value={this.state.loc_type}
                        label="Type"
                        options={[
                            <option>Bureaux</option>,
                            <option>Centrale</option>,
                            // <option>Service</option>,
                            <option>Site</option>,
                            <option>Point de Relais</option>,
                        ]}
                    />
                }
                <InputText
                    required
                    name="loc_ref" 
                    id="loc_ref" 
                    value={this.state.loc_ref} 
                    label="Code Reference" 
                    placeholder="ex: 607" 
                    onChange={this.handleChange}
                    error={this.state.errors.loc_ref} 
                />

                <InputText
                    required
                    name="loc_desc" 
                    id="loc_desc" 
                    value={this.state.loc_desc} 
                    label="Description"
                    multiline 
                    onChange={this.handleChange}
                    error={this.state.errors.loc_desc} 
                />

                <FormControl variant="outlined"  error={!!this.state.errors.loc_color} style={{width: "100%",}}>
                    <Typography>Couleur de la localisation (Localisation principale)</Typography>
                    <Box style={{
                            backgroundColor:this.state.loc_color,
                            width: "50px",
                            height: "50px"
                        }}
                    >
                    </Box>
                    <FormHelperText>{this.state.errors.loc_color}</FormHelperText>
                </FormControl>

                {!this.state.loc_parent &&
                // {!this.state.loc_parent && !this.props.hasChild &&
                    <Box style={{overflow: "auto"}}>
                        <ColorPicker 
                            setColor={this.setColor} 
                            selected={this.state.loc_color} 
                            notAvailable={this.state.exist} 
                            max="16"
                        />
                    </Box>
                }
            </Dialog>
            
        );
    }
}

export default Localisation;